export enum TrackerType {
  RFID = 0,
  Barcode = 1,
  Sigfox = 2,
  BLE = 3,
  LTE = 4,
}

export enum TrackerTypeSearchParam {
  RFID = 'rfid',
  BARCODE = 'barcode',
  SIGFOX = 'sigfox',
  BLE = 'ble',
  LTE = 'lte',
}

/**
 * Qualitative battery level, reported by trackers that send no battery voltage. A tracker that never
 * reported one has no value at all, which the overview shows as unknown.
 */
export enum BatteryStatus {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

export enum BatteryStatusSearchParam {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  UNKNOWN = 'unknown',
}

export enum LinkedTrackerSearchParam {
  LINKED = 'linked',
  UNLINKED = 'unlinked',
}

export interface TrackerReadDTO extends TrackerCreateDTO {
  id: number;

  batteryVoltage?: number | null | undefined;
  batteryVoltageUpdatedAt?: Date | null | undefined;
  batteryStatus?: BatteryStatus | null | undefined;
  batteryStatusUpdatedAt?: Date | null | undefined;
  modelType?: string | null | undefined;
  iccid?: string | null | undefined;

  asset?: {
    id: number;
    code: string;
    assetType: {
      id: number;
      code: string;
    };
  };

  location?: {
    id: number;
    code: string;
    name?: string;
  };

  lastEventDate?: Date | null;

  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface TrackerUpdateDTO extends TrackerCreateDTO {}
export interface TrackerCreateDTO {
  type: TrackerType;
  epc?: string | null | undefined;
  barcode?: string | null | undefined;
  deviceId?: string | null | undefined;
}

export enum TrackerSortOption {
  TYPE = 'type',
  UNIQUE_IDENTIFIER = 'unique-identifier',
  ASSET_CODE = 'asset-code',
  LOCATION_NAME = 'location-name',
  BATTERY_VOLTAGE = 'battery-voltage',
  BATTERY_STATUS = 'battery-status',
  LAST_EVENT_DATE = 'last-event-date',
  MODEL = 'model',
  ICCID = 'iccid',
}

export interface TrackerFilterOptionsDTO {
  searchText?: string;
  trackerType?: TrackerTypeSearchParam | null;
  linkedAsset?: boolean | null;
  batteryStatus?: BatteryStatusSearchParam | null;
}
